module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-14-4ce013761aad4816ab369018f7d93b48.jpg";